export default __webpack_public_path__ + "static/media/igbo.9b72771f.PNG";